import { styled } from '@mui/material/styles'

const AppWrapper = styled('div')`
  display: flex;
  height: 100%;
`

export { AppWrapper }
